import { Col, Row } from "react-bootstrap";
import styled from "styled-components";

export const Content = styled.form`
    margin-bottom: 100px;
`;

export const FormRow = styled(Row)`
    margin: 0 0 1rem 0;
`;

export const FormColumn = styled(Col)`
    margin: 0;
    padding: 0;
`;

export const FormField = styled.div`

`;

export const Action = styled.div`
    text-align: right;
    > button.MuiButton-root {
        margin-left: 2rem;
        margin-right: 0;
        min-width: 6.75rem;
        height: 2.625rem;
    }
    > button.MuiButton-root:hover {
        opacity: 0.75;
        box-shadow: none;
        background-color: ${globalThis.config.colors.black};
    }

    position: absolute;
    bottom: 0;
    right: 0;
    width: 19.375rem;
`;

export const SecondaryButtonWrapper = styled.div`
    float: left;
`;

export const StyledSpecifyDaysText = styled.span`
    color: ${() => globalThis.config.colors.gray2};
    margin-bottom: 0rem;
`;
